import { Box, useRadio } from '@chakra-ui/react'

import { noOp } from '@/utils/helpers'

import FormContentBlock from '@/components/UI/Form/FormContentBlock'
import type { FormDirection, FormInputType } from '@/components/UI/Form/types'

type RadioInput = FormInputType & { type: 'radio' }

export default function OnboardingInputRadioItem({
  label,
  direction,
  radioPayload,
}: {
  label: RadioInput['options'][number]['label']
  direction: FormDirection
  radioPayload: Record<string, unknown>
}): JSX.Element {
  const { getInputProps, getRadioProps } = useRadio(radioPayload)

  const { onChange, ...inputProps } = getInputProps()
  const radioProps = getRadioProps()

  return (
    <Box
      {...radioProps}
      as="label"
      cursor="pointer"
      border="2px solid"
      borderColor="border.emphasized"
      fontWeight="600"
      color="primary.fg"
      borderRadius="8px"
      _checked={{
        bg: 'primary.subtle',
        color: 'primary.fg',
        borderColor: 'primary.border',
      }}
      _focus={{ boxShadow: 'outline' }}
      flex={direction === 'horizontal' ? 1 : 0}
      flexBasis={0}
    >
      <input
        {...inputProps}
        // The default input doesn't process `onChange` when the same radio is clicked
        // twice. Because we want to allow "unchecking" radio options, we just map
        // `onClick` -> `onChange` so we receive ALL click events, not just changed
        // values.
        onClick={onChange}
        onChange={noOp}
      />
      <FormContentBlock content={label} />
    </Box>
  )
}
